<template>
  <div
    v-if="visible"
    class="nup-confirm"
    @click.self="$emit('close')"
  >
    <div class="nup-confirm__wrap">
      <div class="nup-confirm__card">
        <p class="nup-confirm__title">
          {{ copy.confirmTitle }}
        </p>
        <p class="nup-confirm__desc">
          {{ copy.confirmDesc }}
        </p>
        <img
          class="nup-confirm__prize"
          :src="cardSrc"
          alt=""
        >
        <div class="nup-confirm__actions">
          <button
            type="button"
            class="nup-confirm__btn nup-confirm__btn--ghost"
            @click="$emit('close')"
          >
            {{ copy.thinkAgain }}
          </button>
          <button
            type="button"
            class="nup-confirm__btn nup-confirm__btn--ok"
            :disabled="disabled"
            @click="$emit('confirm', resolvedKey)"
          >
            {{ copy.confirm }}
          </button>
        </div>
      </div>
      <button
        type="button"
        class="nup-confirm__close"
        @click="$emit('close')"
      >
          <img
            :src="closeIcon"
            :alt="copy.close"
            width="48"
            height="48"
          >
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { computed } from 'vue-demi';
import { DEFAULT_CHOICE_KEY, isChoiceKey, type ChoiceKey } from '@ark/nup-shared';
import { getCopy } from '../constants/copy';
import { findChoiceConfirmImage } from '../constants/rewards';
import { useNupLang } from '../composables/use-nup-lang';
import closeIcon from '../assets/dialog-close.svg';
const __sfc_main = {};
__sfc_main.props = {
  visible: {
    type: Boolean,
    default: false
  },
  choiceKey: {
    type: String,
    default: DEFAULT_CHOICE_KEY
  },
  disabled: {
    type: Boolean,
    default: false
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const {
    isEn
  } = useNupLang();
  const copy = computed(() => getCopy(isEn.value));
  const resolvedKey = computed<ChoiceKey>(() => {
    return isChoiceKey(props.choiceKey) ? props.choiceKey : DEFAULT_CHOICE_KEY;
  });
  const cardSrc = computed(() => {
    return findChoiceConfirmImage(resolvedKey.value, isEn.value);
  });
  return {
    closeIcon,
    copy,
    resolvedKey,
    cardSrc
  };
};
export default __sfc_main;
</script>

<style scoped>
.nup-confirm {
  position: fixed;
  inset: 0;
  z-index: 40;
  overflow-y: auto;
  padding: 80px 24px;
  box-sizing: border-box;
  background: rgba(0, 0, 0, 0.45);
}

.nup-confirm__wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 620px;
  max-width: 100%;
  margin: 0 auto;
}

.nup-confirm__card {
  width: 100%;
  padding: 56px 40px 48px;
  border-radius: 48px;
  background: #fff;
  text-align: center;
  box-sizing: border-box;
}

.nup-confirm__title {
  margin: 0;
  font-size: 40px;
  color: #000;
  font-weight: 700;
  line-height: 1.3;
}

.nup-confirm__desc {
  margin: 16px 0 40px;
  font-size: 28px;
  color: #b0b0b0;
  line-height: 1.4;
}

.nup-confirm__prize {
  display: block;
  width: 100%;
  max-width: 420px;
  height: auto;
  margin: 0 auto 48px;
}

.nup-confirm__actions {
  display: flex;
  gap: 20px;
}

.nup-confirm__btn {
  flex: 1;
  height: 88px;
  padding: 0;
  border-radius: 44px;
  font-size: 32px;
  font-weight: 600;
  line-height: 88px;
  cursor: pointer;
}

.nup-confirm__btn--ghost {
  background: #fff;
  border: 3px solid #ff6900;
  color: #ff6900;
}

.nup-confirm__btn--ok {
  border: none;
  background-image: linear-gradient(90deg, #ff6900 4%, #ff902a 100%);
  color: #fff;
}

.nup-confirm__btn--ok:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.nup-confirm__close {
  margin-top: 32px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  width: 48px;
  height: 48px;
}

.nup-confirm__close img {
  display: block;
  width: 48px;
  height: 48px;
}

.nup-page.is-pc .nup-confirm {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
}

.nup-page.is-pc .nup-confirm__wrap {
  width: 400px;
}

.nup-page.is-pc .nup-confirm__card {
  padding: 36px 28px 32px;
  border-radius: 24px;
}

.nup-page.is-pc .nup-confirm__title {
  font-size: 22px;
}

.nup-page.is-pc .nup-confirm__desc {
  margin: 8px 0 24px;
  font-size: 14px;
}

.nup-page.is-pc .nup-confirm__prize {
  max-width: 240px;
  margin-bottom: 28px;
}

.nup-page.is-pc .nup-confirm__actions {
  gap: 12px;
}

.nup-page.is-pc .nup-confirm__btn {
  height: 48px;
  border-radius: 24px;
  font-size: 16px;
  line-height: 48px;
}

.nup-page.is-pc .nup-confirm__btn--ghost {
  border-width: 2px;
}

.nup-page.is-pc .nup-confirm__close {
  margin-top: 16px;
}
</style>
